export default function TailArrow({ ...props }) {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Tail icon">
        <path
          id="Shape"
          d="M8.33623 4.62149C8.63615 4.3358 9.11088 4.34734 9.39657 4.64726L14.3979 9.89773C14.6738 10.1874 14.6738 10.6426 14.3979 10.9323L9.39657 16.1828C9.11088 16.4827 8.63615 16.4942 8.33623 16.2085C8.0363 15.9228 8.02477 15.4481 8.31046 15.1482L12.819 10.415L8.31046 5.68184C8.02477 5.38192 8.0363 4.90719 8.33623 4.62149Z"
          fill="#0E0E0E"
        />
      </g>
    </svg>
  );
}
